<template>
  <div :class="`md-layout-item md-size-${size} md-small-size-${smallSize||size*2} md-xsmall-size-100`">
    <label>{{label}}</label>
    <p class="field-content">
      <slot>
      {{value}}
      </slot>
    </p>
  </div>
</template>

<script>
export default {

  name: 'Field',

  props: {
    label: {
      type: String,
      required: true
    },
    smallSize: {
      type: Number,
      default: 50,
    },
    size: {
      type: Number,
      default: 25
    },
    value: {
      required: false,
    }
  },

  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
  .field-content {
   word-wrap:break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/FField.vue